export default __webpack_public_path__ + "static/media/nginx_monitor.b589b9ff.md";